<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="1350px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-chart-line</v-icon>
            <span class="px-3">{{ $t("View Total Inventory's information") }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea" style="padding: 16px 8px">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <table class="section-title-table only-for-print">
            <tr>
              <th class="section-title-content">
                {{ $t('Inventories Report') }}
              </th>
            </tr>
          </table>

          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-0': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <table class="printed-table" cellspacing="0">
                  <thead>
                    <tr class="only-for-print">
                      <td>
                        <div class="header-space">&nbsp;</div>
                      </td>
                    </tr>
                    <tr>
                      <th xs1 class="pa-2 view-table-header">#</th>
                      <th class="view-table-header" xs2>{{ $t('Outlet') }}</th>
                      <th class="view-table-header" xs2>{{ $t('Asset Name') }}</th>
                      <th class="view-table-header" xs1>
                        {{ $t('Asset Type') }}
                      </th>
                      <th class="view-table-header" xs1>{{ $t('Barcode') }}</th>
                      <!--                      <th class="view-table-header" xs1>{{ $t('Input') }}</th>-->
                      <!--                      <th class="view-table-header" xs1>{{ $t('Output') }}</th>-->
                      <th class="view-table-header" xs1>
                        {{ $t('Quantity') }}
                      </th>
                      <!--                      <th class="view-table-header" xs1>-->
                      <!--                        {{ $t('Quantity Alarm') }}-->
                      <!--                      </th>-->
                      <!--                      <th class="view-table-header" xs1>-->
                      <!--                        {{ $t('Shortage') }}-->
                      <!--                      </th>-->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in rowNumbers" :key="index">
                      <td class="view-table-row">
                        <p class="view-table-content">{{ index + 1 }}</p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.outlet[index] }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.product_name[index] }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.product_type_name[index] }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.product_barcode[index] }}
                        </p>
                      </td>
                      <!--                      <td class="view-table-row">-->
                      <!--                        <p class="view-table-content">-->
                      <!--                          {{ viewInfo.input[index] }}-->
                      <!--                        </p>-->
                      <!--                      </td>-->
                      <!--                      <td class="view-table-row">-->
                      <!--                        <p class="view-table-content">-->
                      <!--                          {{ viewInfo.output[index] }}-->
                      <!--                        </p>-->
                      <!--                      </td>-->
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.quantity[index] | currency }}
                        </p>
                      </td>
                      <!--                      <td class="view-table-row">-->
                      <!--                        <p class="view-table-content">-->
                      <!--                          {{ viewInfo.quantity_alarm[index] | currency }}-->
                      <!--                        </p>-->
                      <!--                      </td>-->
                      <!--                      <td class="view-table-row">-->
                      <!--                        <p class="view-table-content">-->
                      <!--                          {{ viewInfo.shortage[index] === false ? 'No shortage' : 'Shortage' }}-->
                      <!--                        </p>-->
                      <!--                      </td>-->
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="only-for-print">
                      <td>
                        <div class="footer-space">&nbsp;</div>
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <invoice-footer
                  :showSignatureSection="false"
                  :accountantName="''"
                  :payerRecipientName="''"
                  :payerOrRecipient="''"
                  class="only-for-print"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Close') }}</v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      rowNumbers: 0,
      viewInfo: {
        outlet: [],
        product_name: [],
        product_barcode: [],
        product_type_name: [],
        input: [],
        output: [],
        quantity: [],
        quantity_alarm: [],
        shortage: []
      }
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      totalInventoryInfo: 'inventory/getTotalInventoryInfo'
    })
  },

  watch: {
    viewDialog: {
      immediate: false,
      handler() {
        if (this.viewDialog) {
          this.rowNumbers = this.totalInventoryInfo.length
          this.viewInfo.outlet = []
          this.viewInfo.product_name = []
          this.viewInfo.product_barcode = []
          this.viewInfo.product_type_name = []
          this.viewInfo.input = []
          this.viewInfo.output = []
          this.viewInfo.quantity = []
          this.viewInfo.quantity_alarm = []
          this.viewInfo.shortage = []

          this.totalInventoryInfo.forEach(c => {
            this.viewInfo.outlet.push(c.outlet_name)
            this.viewInfo.product_name.push(c.product_name)
            this.viewInfo.product_barcode.push(c.product_barcode)
            this.viewInfo.product_type_name.push(c.product_type_name)
            this.viewInfo.input.push(c.input)
            this.viewInfo.output.push(c.output)
            this.viewInfo.quantity.push(c.quantity)
            this.viewInfo.quantity_alarm.push(c.quantity_alarm)
            this.viewInfo.shortage.push(c.shortage)
          })
        }
      }
    }
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    printMe() {
      let onlyForPrint = document.querySelectorAll('.only-for-print')
      let notPrintable = document.querySelectorAll('.not-printable')
      let invoiceContent = document.querySelector('.invoice-content')
      let theDialogContent = document.querySelector('.view-dialog-content')
      theDialogContent.classList.remove('grey')
      invoiceContent.style.marginTop = '90px'
      notPrintable.forEach(element => {
        element.style.display = 'none'
      })
      onlyForPrint.forEach(element => {
        element.style.display = 'block'
      })
      document.querySelector('.printed-table').style.marginTop = '-120px'

      this.$htmlToPaper('printArea', () => {
        theDialogContent.classList.add('grey')
        invoiceContent.style.marginTop = '0px'
        onlyForPrint.forEach(element => {
          element.style.display = 'none'
        })
        notPrintable.forEach(element => {
          element.style.display = 'flex'
        })
        document.querySelector('.printed-table').style.marginTop = '0px'
      })
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
